import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";
import { useQuery } from "@vue/apollo-composable";
import { queries } from "@/apollo";
import { customMoment } from "@/main";
import { User, DdPage } from "@/CodegenTypes";
import { formatDollar } from "@/helpers/formatDollar";
import { formatCount } from "@/helpers/formatCount";
import { startCase, groupBy } from "lodash";
import PageDetailsModal from "../bet-details/PageDetailsModal.vue";
import { useTranslation } from "@/store/translation";


export default /*#__PURE__*/_defineComponent({
  __name: 'CopyBetModal',
  props: {
    value: { type: Boolean, default: false },
    userId: null
  },
  emits: ["input", "copy"],
  setup(__props: any, { emit }: { emit: ({
  (e: "input", val: boolean): void;
  (e: "copy", page: DdPage): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: boolean, userId: User["userId"] };





const { $t } = useTranslation();
const t = (text: string) => $t(text);

const selectedPage = ref<null | DdPage>(null);
const showPageDetailModal = ref(false);

const releaseDateStart = customMoment()
  .add(-3, "weeks")
  .startOf("day")
  .toDate();

const releaseDateEnd = customMoment()
  .startOf("day")
  .toDate();

const queryVariables = computed(() => ({
  releaseDateStart,
  releaseDateEnd,
  behalfOf: props.userId,
}));

const { result, loading: apolloLoading, refetch } = useQuery<{ user: User }>(
  queries.userPages,
  queryVariables,
  {
    enabled: computed(() => !!props.userId && !!props.value),
    fetchPolicy: "cache-and-network",
  }
);

const user = computed(() => result.value?.user ?? null);

const processedPagesByReleaseDate = computed(() => {
  const pages = user.value?.pages ?? [];
  return Object.entries(groupBy(pages, (page) => page.releaseDate))
    .sort(([releaseDateA], [releaseDateB]) => {
      return customMoment(releaseDateB).unix() - customMoment(releaseDateA).unix();
    })
    .map(([releaseDate, pages]) => {
      const bigCount = pages.reduce((acc, page) => acc + page.calculation.bigCount, 0);
      const smallCount = pages.reduce((acc, page) => acc + page.calculation.smallCount, 0);
      const rawCost = pages.reduce((acc, page) => acc + page.calculation.rawCost, 0);
      return {
        releaseDate,
        pages,
        agg: {
          bigCount,
          smallCount,
          rawCost,
        },
      };
    })
    .sort((a, b) => {
      return customMoment(b.releaseDate).unix() - customMoment(a.releaseDate).unix();
    });
});

function toggleModal(val: boolean) {
  emit("input", val);
}

function openPage(page: DdPage) {
  selectedPage.value = page;
  showPageDetailModal.value = true;
}

function handleSubmit() {
  toggleModal(!props.value);
}

function reloadAll() {
  refetch(queryVariables.value);
}

function formatDatetime(dateStr: string | Date) {
  return customMoment(dateStr).fromNow();
}

function formatReleaseDate(dateStr: string | Date) {
  return customMoment(dateStr).format("ddd, DD/MM/YYYY");
}

function handleCopy(id: DdPage["id"]) {
  const page = user.value?.pages.find((page) => page.id === id);
  if (!page) {
    return;
  }
  emit("copy", page);
  toggleModal(false);
}

return { __sfc: true,props, emit, $t, t, selectedPage, showPageDetailModal, releaseDateStart, releaseDateEnd, queryVariables, result, apolloLoading, refetch, user, processedPagesByReleaseDate, toggleModal, openPage, handleSubmit, reloadAll, formatDatetime, formatReleaseDate, handleCopy, formatDollar, formatCount, startCase, PageDetailsModal }
}

})